import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Chip,
} from "@mui/material";
import { ExcessInventoryAlert } from "./types";
import { formatToMillions, roundToDecimalPlaces } from "../../../utils/numbers";

export const ExcessInventoryList = ({ alerts }: { alerts: ExcessInventoryAlert[] }) => {
  if (alerts.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No excess inventory found
      </Typography>
    );
  }

  // Sort by inventory value (descending)
  const sortedAlerts = [...alerts].sort(
    (a, b) => b.inventory_value - a.inventory_value
  );

  // Show top 20 for performance
  const displayAlerts = sortedAlerts.slice(0, 20);

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell><strong>SKU</strong></TableCell>
            <TableCell><strong>Location</strong></TableCell>
            <TableCell><strong>Category</strong></TableCell>
            <TableCell align="right"><strong>Quantity</strong></TableCell>
            <TableCell align="right"><strong>Inventory Value</strong></TableCell>
            <TableCell align="right"><strong>Months of Supply</strong></TableCell>
            <TableCell align="right"><strong>Monthly Demand</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {displayAlerts.map((alert, index) => (
            <TableRow
              key={`${alert.sku}-${alert.location}-${index}`}
              sx={{ "&:hover": { backgroundColor: "action.hover" } }}
            >
              <TableCell>
                <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
                  {alert.sku}
                </Typography>
              </TableCell>
              <TableCell>{alert.location}</TableCell>
              <TableCell>
                <Chip
                  label={alert.product_category}
                  size="small"
                  variant="outlined"
                />
              </TableCell>
              <TableCell align="right">
                {roundToDecimalPlaces(alert.quantity)} units
              </TableCell>
              <TableCell align="right">
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {formatToMillions(alert.inventory_value)}
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="body2" color="warning.main">
                  {roundToDecimalPlaces(alert.months_of_supply)} months
                </Typography>
              </TableCell>
              <TableCell align="right">
                {roundToDecimalPlaces(alert.monthly_demand)} units/mo
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {alerts.length > 20 && (
        <Typography
          variant="caption"
          sx={{ p: 1, display: "block", textAlign: "center", color: "text.secondary" }}
        >
          Showing top 20 of {alerts.length} excess inventory items (sorted by value)
        </Typography>
      )}
    </TableContainer>
  );
};
